import { tuple } from '../_util/type';
const DatePickerModes = tuple('time', 'date', 'month', 'year', 'decade');
